import {DG_axios} from "../../../custom/axios";

const BASE_URI = `/dogoo/contract-type-config-rest/v2.0/contract-types/`;

export const loadContractsApi = async (params) => {
    const config = {params: params};
    const response = await DG_axios.get(BASE_URI, config);

    return response.data || [];
};
